<template>
    <div class="color-input-wrapper" :class="{ small: small }">
        <input
            type="color"
            id="colorPicker"
            :value="selectedColor"
            @input="validateAndEmitHexColor"
        />
        <!-- Dropdown icon -->
        <i v-if="!noCaret" class="fa fa-caret-down ml-1"></i>
    </div>
</template>

<script>
export default {
    props: {
        selectedColor: {
            type: String,
            default: "#ff0000"
        },
        noCaret: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {},
    methods: {
        validateAndEmitHexColor(event) {
            const selectedColor = event.target.value;
            this.$emit("updateSelectedColor", selectedColor.toUpperCase());
        }
    }
};
</script>

<style scoped>
.color-input-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
    background-color: #f0f0f0;
    padding: 5px;
    width: 150px;
    height: 40px;
}

/* Style for the input to look rectangular */
input[type="color"] {
    width: 100%;
    height: 100%;
    border: none;
    padding-right: 30px;
    box-sizing: border-box;
    appearance: none;
    background-color: #f0f0f0;
    cursor: pointer;
    border-radius: 4px;
}
/* Ensure the color swatch is rectangular */
input[type="color"]::-webkit-color-swatch {
    border: none;
}

input[type="color"]::-webkit-color-swatch-wrapper {
    padding: 0;
    border: none;
}

/* Style for the dropdown icon */
.fa-caret-down {
    position: absolute;
    right: 10px;
    font-size: 14px;
    color: #666;
    pointer-events: none; /* Make sure the caret icon doesn't interfere with clicks */
}

.small {
    padding: 3px;
    width: 80px;
    height: 30px;
    border-radius: 5px;
}
</style>
